import React from 'react';
import { FormInputSelect } from '../../../common/formInputs/FormInputSelect';
import { FormInputText } from '../../../common/formInputs/FormInputText';

const questions = {
  building_plans: {
    label: "Piani dell'edificio",
    name: 'building_plans',
    input_type: 'number',
  },
  occupied_floor: {
    label: 'Piani occupati',
    name: 'occupied_floor',
    options: [
      {
        id: 'Piano Terra',
        name: 'Piano Terra',
      },
      {
        id: 'Piani Superiori',
        name: 'Piani Superiori',
      },
      {
        id: 'Piano Interrato',
        name: 'Piano Interrato',
      },
    ],
    condition_key: 'type.building_type',
    condition_value: 'Porzione di fabbricato',
  },
  construction_year: {
    label: 'Anno di costruzione',
    name: 'construction_year',
    options: [
      {
        id: 'Prima del 1936',
        name: 'Prima del 1936',
      },
      {
        id: 'Tra il 1936 e il 1996',
        name: 'Tra il 1936 e il 1996',
      },
      {
        id: 'Tra il 1997 e il 2008',
        name: 'Tra il 1997 e il 2008',
      },
      {
        id: 'Dopo il 2008',
        name: 'Dopo il 2008',
      },
    ],
  },
  construction_typology: {
    label: 'Tipologia costruttiva - strutture portanti verticali',
    name: 'construction_typology',
    options: [
      {
        id: 'Acciaio',
        name: 'Acciaio',
      },
      {
        id: 'Legno',
        name: 'Legno',
      },
      {
        id: 'Cemento armato',
        name: 'Cemento armato',
      },
      {
        id: 'Muratura',
        name: 'Muratura',
      },
    ],
  },
};
function CommercialCatastropheContractorOtherData({
  errors,
  isValid,
  register,
  answers,
}) {
  const getNestedValue = (obj, path) => path.split('.').reduce((acc, part) => acc && acc[part], obj);

  return (
    <>
      <h4 className="text-center mt-3">Altri Dati</h4>
      <div className="row mt-5 d-flex justify-content-center">
        <div className="col-12 col-md-6 mb-4">
          <div className="card border">
            <div className="card-body">
              <div className="col-12">
                <div
                  className="d-flex flex-column align-items-center justify-content-center gap-5"
                  style={{ maxWidth: '600px' }}
                >
                  {Object.values(questions).map((question, index) => {
                    if (['number', 'text'].includes(question.input_type)) {
                      return (
                        <FormInputText
                          key={index}
                          label={question.label}
                          type={question.input_type}
                          placeholder={question.label}
                          registration={register(`other_data.${question.name}`)}
                          error={errors.other_data?.[question.name]?.message}
                          valid={isValid(`other_data.${question.name}`)}
                        />
                      );
                    }
                    if ((question.options && !question.condition_key)
                      || (question.name === 'occupied_floor'
                        && getNestedValue(answers, question.condition_key) === question.condition_value)) {
                      return (
                        <FormInputSelect
                          key={index}
                          placeholder="-Seleziona-"
                          label={question.label}
                          options={question.options}
                          name={question.name}
                          error={errors?.other_data?.[question.name]?.message}
                          valid={isValid(`other_data.${question.name}`)}
                          registration={register(`other_data.${question.name}`)}
                        />
                      );
                    }
                    return null; // Add fallback return
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CommercialCatastropheContractorOtherData;
